import type React from 'react';

import { NumbersRounded } from '@mui/icons-material';
import {
  OrdReferenceField,
  OrdDatagrid,
  OrdCreateDialog,
  OrdEditDialog,
  OrdList,
} from '@ragu-components/ord-components';
import { Resources } from '@ragu-components/ord-resources';
import { UserNumberFields } from '@ragu-components/ord-types';
import { TextField } from 'react-admin';

import { UserNumbersForm } from './UserNumbersForm';

import type { ResourceType } from '../../personal';
import type { OrdDatagridProps, OrdListProps } from '@ragu-components/ord-components';

interface UserNumberListProps extends Partial<Omit<OrdListProps, 'empty'>>, ResourceType {
  embeddedChildren?: React.ReactElement | React.ReactElement[];
  empty?: OrdDatagridProps['empty'];
}

export const UserNumberList = ({
  embeddedChildren = undefined,
  empty = undefined,
  layout = 'full',
  ...props
}: UserNumberListProps): React.ReactElement => (
  <>
    <OrdList
      icon={<NumbersRounded />}
      layout={layout}
      sort={{ field: UserNumberFields.number, order: 'ASC' }}
      {...props}
    >
      <OrdDatagrid layout={layout} empty={empty}>
        <TextField source={UserNumberFields.number} />
        <TextField source={UserNumberFields.description} />
        {layout === 'full' && <OrdReferenceField source={UserNumberFields.owner} reference={Resources.users} />}
        {embeddedChildren}
      </OrdDatagrid>
    </OrdList>
    {layout === 'full' && (
      <OrdCreateDialog>
        <UserNumbersForm />
      </OrdCreateDialog>
    )}
    {layout === 'full' && (
      <OrdEditDialog>
        <UserNumbersForm />
      </OrdEditDialog>
    )}
  </>
);

export default UserNumberList;
